<template>
  <div>

<!--    <pre>-->
<!--      {{$store.getters.getInvoiceProduct}}-->
<!--    </pre>-->

    <template
            v-if="$store.getters.getInvoiceProduct.length > 0 && $store.getters.getInvoiceProductLoading !== true">
      <div class="custom-row pt-4">
        <div class="custom-col custom-col--20 custom-col--xs-100 custom-col--md-50 custom-col--xl-33"
             v-for="(item, index) in $store.getters.getInvoiceProduct"
             :key="index"
        >
          <div class="case-cart">
            <div class="case-cart__inner">

              <div class="case-cart__head"></div>
              <div class="case-cart__body">
                <div class="case-cart__row custom-row">
                  <div class="case-cart__col custom-col"
                       v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
                    <div class="admin-edit" @click="editTranslate([
                        'product_simpleProductName',
                      ])"></div>
                    <b class="case-cart__subtitle-prof">
                      {{item.item_name}}
                    </b>
                  </div>
                </div>
                <div class="case-cart__row custom-row">

                  <TableUserNameRow
                          v-if="isAdmin"
                          :item="item"
                  />

                  <div class="case-cart__col custom-col custom-col--50"
                       v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
                    <div class="admin-edit" @click="editTranslate([
                        'common_PricePerItem',
                      ])"></div>
                    <div class="case-cart__label">
                      {{$t('common_PricePerItem.localization_value.value')}}
                    </div>
                    <div class="case-cart__content">
                      {{item.price}}
                    </div>
                  </div>

                  <div class="case-cart__col custom-col custom-col--50"
                       v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
                    <div class="admin-edit" @click="editTranslate([
                        'common_ItemsQty',
                      ])"></div>
                    <div class="case-cart__label">
                      {{$t('common_ItemsQty.localization_value.value')}}
                    </div>
                    <div class="case-cart__content">
                      {{item.quantity}}
                    </div>
                  </div>

                </div>
              </div>

              <div class="case-cart__bottom">
                <div class="case-cart__btn ml-auto">
                  <CaseCartButton
                          class="secondary-brown"
                          :value="$t('common_delete.localization_value.value')"
                          @click.native="deleteItem(item.id, index)"
                          :ico="true"
                          :typeIco="'delete-brown'"
                  >
                  </CaseCartButton>
                </div>
                <div class="case-cart__btn ml-auto">
                  <CaseCartButton
                          :value="$t('common_edit.localization_value.value')"
                          :ico="true"
                          :typeIco="'edit'"
                          @click.native="editItem(item.id)"
                  >
                  </CaseCartButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {{$store.getters.getInvoiceProductCommonList.next_page_url}}
      <div class="table-bottom-btn"
           v-if="$store.getters.getInvoiceProductCommonList.next_page_url !== null && $store.getters.getInvoiceProduct.length > 0">
        <div class="table-bottom-btn__inner">
          <ShowMore
                  v-if="$store.getters.getInvoiceProductCommonList.next_page_url !== null && $store.getters.getInvoiceProduct.length > 0"
                  @click.native="$emit('showMore')"
                  v-bind:class="{'disabled-btn' : $store.getters.getNextInvoiceProductPage}"
                  :count="$store.getters.getInvoiceProductCommonList.total - $store.getters.getInvoiceProductForPage < $store.getters.getInvoiceProductForPage ?
                $store.getters.getInvoiceProductCommonList.total - $store.getters.getInvoiceProductForPage:
                $store.getters.getInvoiceProductForPage"
          />
        </div>
      </div>
    </template>
    <template
            v-if="$store.getters.getInvoiceProduct.length === 0 && $store.getters.getInvoiceProductLoading === false">
      <NoResult
              :countFilterParams="countFilterParams"
              :title="$t('common_noDataYet.localization_value.value')"
              :titleWithFilter="$t('common_noResult.localization_value.value')"
              :text="$t('common_noDataYetTxt.localization_value.value')"
              :textWithFilter="$t('common_noResultSeems.localization_value.value')"
              @resetFilter="$emit('resetFilter')"
      />
    </template>


    <AddingInvoiceProductPopup
            v-if="isModalAddingProfilePopup"
            :id="idSelectedItem"
            :edit="true"
            @close="changeAddingProfilePopup(false)"
            @reload="$emit('reload')"
    />

  </div>
</template>

<script>
  import CaseCartButton from "../../../../../../../UI/buttons/CaseCartButton/CaseCartButton";
  import NoResult from "../../../../../../../coreComponents/NoResult/NoResult";
  import ShowMore from "../../../../../../../coreComponents/Buttons/ShowMore/ShowMore";
  import AddingInvoiceProductPopup from "../../../../../popups/AddingInvoiceProductPopup/AddingInvoiceProductPopup";
  import TableUserNameRow from "../../../../../../../coreComponents/TableComponents/TableUserNameRow/TableUserNameRow";

  export default {
    name: "ProfilesInvoiceProductTable",
    components: {TableUserNameRow, AddingInvoiceProductPopup, ShowMore, NoResult, CaseCartButton},

    props: {
      countFilterParams: Number,
    },

    data() {
      return {
        isModalAddingProfilePopup: false,
        idSelectedItem: false,
      }
    },

    mounted() {

    },

    methods: {
      editItem(id) {
        this.idSelectedItem = id
        this.$store.dispatch('getInvoiceProduct', id).then(() => {
          this.changeAddingProfilePopup(true)
        })
      },

      deleteItem(id, index) {
        let text = {
          title: 'common_deleteConfirm',
          txt: 'common_deleteItemAsk',
          yes: 'common_confirmDelete',
          no: 'common_confirmNo'
        }

        let confirm = () => {

          this.$store.dispatch('deleteInvoiceProduct', id).then((response) => {
            if (this._.has(response, 'data') && response.status === this.$store.getters.GET_ERRORS.SUCCESS_CODE) {

              let profilesPackaging = this.$store.getters.getInvoiceProduct
              profilesPackaging.splice(index, 1)

              this.openNotify('success', 'common_notificationRecordDeleted')
            } else {
              setTimeout(() => {
                this.openNotify('error', 'common_notificationUndefinedError')
              }, 200)
            }
          })

          this.$store.commit('setConfirmDeletePopup', false)
          return true
        }

        this.deleteFunc(text, confirm)
      },

      changeAddingProfilePopup(val) {
        this.isModalAddingProfilePopup = val
      },
    }
  }
</script>

<style scoped>

</style>
